// components/AboutDialog.tsx
'use client';
import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';

export default function AboutDialog({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  return (
    <Transition show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-50" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-2xl transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                <Dialog.Title className="text-xl font-bold leading-6 text-blue-700">ℹ️ About AI Copilot</Dialog.Title>
                <div className="mt-4 text-gray-700 space-y-4 text-base">
                  <p>This project is an AI Copilot for Curiosity-Based Reframing of Textbook Content, designed for high school students.</p>
                  <p><strong>Key Features:</strong></p>
                  <ul className="list-disc pl-6">
                    <li>Generate curiosity-driven questions</li>
                    <li>Query history tracking and retrieval</li>
                    <li>AI chatbot interactions from selected text</li>
                  </ul>
                  <p><strong>Team Members:</strong> </p>
                  <ul className="list-disc pl-6">
                    <li><b>Nguyễn Khánh An (helix)</b>, 10 Edmonton - The Dewey Schools Tây Hồ Tây</li>
                    <li>Trần Việt Cường, 11D2	- THPT Chu Văn An</li>
                    <li>Nguyễn Công Phúc Lâm, 11QT1 - THPT Trần Nhân Tông</li>
                    <li>Nguyễn Ngọc Anh, 11A10 - THPT Phạm Hồng Thái</li>
                    <li>Phan Minh Châu, 8A1 – THCS Ba Đình</li>
                  </ul>
                  <p><strong>Technologies Used:</strong> OpenAI API, Gemini API, Next.js, Firebase.</p>
                </div>

                <div className="mt-6 text-right">
                  <button
                    type="button"
                    className="inline-flex justify-center rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
                    onClick={onClose}
                  >
                    Close
                  </button>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
}
